import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/distance-calculator',
  component: () => import('../../routes/DistanceCalculator.svelte'),
  card: {
    id: 'distance-calculator',
    title: 'Distance Calculator',
    description: 'Calculate the great-circle distance between two points on Earth using latitude and longitude coordinates.',
    icon: 'distance',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/distance-calculator',
    category: 'Travel & Distance',
  },
  seo: {
    title: 'Distance Calculator – Great-Circle Distance Between Two Points',
    description: 'Free distance calculator that calculates the great-circle distance between two points on Earth using latitude and longitude. Supports miles, kilometers, nautical miles, meters, and feet.',
  },
};

export default meta;